export default "/_next/static/images/b6131d08fa28e7735852587ec58719e0.png";